import * as React from "react";

import { StyledLink } from "../Link/StyledLink";

const defaultValue = {
  Link: {
    component: (props) => <StyledLink {...props} />,
    unstyled: (props) => <StyledLink {...props} />,
  },
  Image: {
    context: [require.context("../static/images", true)],
    lookupTable: {
      "dashed-circle": "icons/dashed-circle.svg",
      "icons/tools": "icons/tools.svg",
      "icons/indemnity": "icons/indemnity.svg",
      "icons/interruption": "icons/interruption.svg",
      "icons/property": "icons/property.svg",
      "mobile-phone": "icons/home-and-away/mobile-phone.svg",
      "mobile-and-tablet": "icons/home-and-away/mobile-and-tablet.svg",
      "mobile-tablet-watch-laptop":
        "icons/home-and-away/mobile-tablet-watch-laptop.svg",
      "device-protection-silver": "icons/home-and-away/device-protection-silver.svg",
      "device-protection-gold": "icons/home-and-away/device-protection-gold.svg",
      "device-protection-platinum":
        "icons/home-and-away/device-protection-platinum.svg",
      "construction/federation": "icons/construction/federation.svg",
      "construction/modern-architect": "icons/construction/modern-architect.svg",
      "construction/modern-project": "icons/construction/modern-project.svg",
      "construction/war": "icons/construction/war.svg",
      "construction/victorian": "icons/construction/victorian.svg",
      "material/aac-panel": "icons/material/aac-panel.svg",
      "material/aluminium": "icons/material/aluminium.svg",
      "material/blockwork": "icons/material/blockwork.svg",
      "material/brick-veneer": "icons/material/brick-veneer.svg",
      "material/double-brick": "icons/material/double-brick.svg",
      "material/fibrecement": "icons/material/fibrecement.svg",
      "material/masonry": "icons/material/masonry.svg",
      "material/panel": "icons/material/panel.svg",
      "material/sheet-cladding": "icons/material/sheet-cladding.svg",
      "material/slate": "icons/material/slate.svg",
      "material/stonework-veneer": "icons/material/stonework-veneer.svg",
      "material/stonework": "icons/material/stonework.svg",
      "material/timber": "icons/material/timber.svg",
      "material/weatherboard": "icons/material/weatherboard.svg",
      "material/wood": "icons/material/wood.svg",
      "security/alarm-local": "icons/security/alarm-local.svg",
      "security/alarm-monitored": "icons/security/alarm-monitored.svg",
      "security/door-deadlock-card": "icons/security/door-deadlock-card.svg",
      "security/door-deadlock-key": "icons/security/door-deadlock-key.svg",
      "security/window-key-locks": "icons/security/window-key-locks.svg",
      "security/window-not-accessible": "icons/security/window-not-accessible.svg",
      "security/window-security-screens": "icons/security/window-security-screens.svg",
    },
  },
};

/**
 * Stores application level configuration.
 *
 * TODO: More details.
 */
const AppProviderContext = React.createContext(defaultValue);

function useAppProvider() {
  return React.useContext(AppProviderContext);
}

const AppProvider = AppProviderContext.Provider;
AppProvider.defaultValue = defaultValue;

export { AppProvider, useAppProvider };
